import { render, staticRenderFns } from "./StudyTask.vue?vue&type=template&id=21a6b498&scoped=true&"
import script from "./StudyTask.vue?vue&type=script&lang=js&"
export * from "./StudyTask.vue?vue&type=script&lang=js&"
import style0 from "./StudyTask.vue?vue&type=style&index=0&id=21a6b498&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a6b498",
  null
  
)

export default component.exports